import type { ReactNode } from 'react'

interface ReportSectionProps {
  id: string
  content: unknown
  children: ReactNode
}

/** Wraps a report section with an anchor ID and consistent spacing. */
export function ReportSection({ id, content, children }: ReportSectionProps) {
  if (!content) return null

  return (
    <section id={id} className="scroll-mt-16">
      {children}
    </section>
  )
}
